import { render, staticRenderFns } from "./check_domain_tag.vue?vue&type=template&id=47edcb07&lang=pug&"
import script from "./check_domain_tag.vue?vue&type=script&lang=js&"
export * from "./check_domain_tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports